export default __webpack_public_path__ + "static/media/poster.982be095.jpeg";